module.exports = __webpack_public_path__ + "media/categories/armor-customization-a6f66a2c.png";